import { useParams } from "react-router-dom";
import React, { useEffect } from 'react';
import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Addsonsectionphoto = () =>{
    const [photo, setPhoto] = useState('');
    const [photo_id , setPhoto_id ] = useState('');
    const [name, setName] = useState('');
    let { id } =  useParams();

    let navigt = useNavigate();
    const handleImage =(e)=>{
        setName(e.target.files[0]) 
    }
    const  formSubmit = (e)=>{
        e.preventDefault()
        const formData = new FormData()
        formData.append('photo', photo)
        formData.append('photo_id', photo_id)
        formData.append('name', name)
 
        axios.post('https://backend.dasta.net/api/auth/addworksectionsonControllerphoto',formData ).then((res)=>{
            console.log(res)
        }).then((data)=>{
            navigt(-1);
        })
    }  

    return(
        <>
        <form onSubmit={formSubmit}>
            <input type="file" name="file" onChange={(e)=>setPhoto(e.target.files[0])}/>   
                <label>Please Enter descrption::</label>
                <input type="text" id="fname" name="fname" onChange={(e)=>setName(e.target.value)}/>
               
                <label>Please Enter number::{id}</label>
                <input type="text" id="fname" name="fname" onChange={(e)=>setPhoto_id(e.target.value)}/>
            <button type='submit' >submit</button>
        </form>
        </>
    )

}
export default Addsonsectionphoto;